<template>
  <TAlert v-if="apiResponseError" kind="red">
    <template #title>
      {{ $t(errorAlert.title) }}
    </template>
    <template #text>
      <ul class="list-disc space-y-1 pl-5">
        <li
          v-for="(errorItem, index) in errorAlert.list"
          :key="index"
          v-html="$t(`error.${errorItem.code}`)"
        />
      </ul>
    </template>
  </TAlert>
</template>

<script setup lang="ts">
import { API_ERROR_CODES_WITH_MESSAGE } from '../../constants'

interface propsInterface {
  apiResponseError: ApiResponseError | null
}
const props = defineProps<propsInterface>()

type arrayErrorsCodes = ApiResponseError['errors']

const genericErrorText: arrayErrorsCodes = [
  {
    code: 0,
    message: '',
  },
]

const getError = (list = genericErrorText) => {
  const dataError: {
    title: string
    list: arrayErrorsCodes
  } = {
    title: 'error.title',
    list,
  }
  return dataError
}

const getErrorList = () => {
  if (
    props.apiResponseError !== null &&
    props?.apiResponseError?.errors?.length > 0
  ) {
    return props.apiResponseError.errors.filter(item => {
      return Object.values(API_ERROR_CODES_WITH_MESSAGE).includes(item.code)
    })
  } else {
    return undefined
  }
}

const errorAlert = computed(() => {
  const errorList = getErrorList()
  return getError(errorList)
})
</script>
